import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';
import { JcButton, JcButtonType } from './button/JcButton';

export interface JcShowEarlierProps extends JcCommonProps {
    /** How many earlier items are hidden. Renders nothing once 0. */
    readonly count: number;
    /** Reveals the hidden items — the caller flips its own render-level state. */
    readonly onShowEarlier: () => void;
    /** Singular noun for the label, e.g. "week" → "Show 3 earlier weeks". Defaults to "item". */
    readonly noun?: string;
}

/**
 * Reveal affordance for items collapsed at the top of a chronological list —
 * the top-side counterpart to `JcLoadMore`. Click-only by design: it never
 * auto-triggers on scroll, so a list anchored at "now" stays anchored until
 * the user asks for the past. Renders nothing once `count` is 0.
 */
export const JcShowEarlier = (props: JcShowEarlierProps): React.ReactElement | null => {
    const { count, onShowEarlier, noun = 'item' } = props;

    if (count <= 0) {
        return null;
    }
    return (
        <div {...JcUtils.commonProps(props, ['jc-show-earlier'])}>
            <JcButton buttonType={JcButtonType.GHOST} onClick={onShowEarlier}>
                {`Show ${count} earlier ${noun}${count === 1 ? '' : 's'}`}
            </JcButton>
        </div>
    );
};
